import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Injectable, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { User } from 'app/core/user/user.types';
import { Subject } from 'rxjs';

@Injectable()
export abstract class BaseUserComponent {
    static ngAcceptInputType_showAvatar: BooleanInput;

    abstract user: User;

    protected _changeDetectorRef = inject(ChangeDetectorRef);
    protected _router = inject(Router);

    protected _unsubscribeAll: Subject<any> = new Subject<any>();

    // Angular Material and common modules for standalone components
    static imports = [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        NgClass,
    ];

    /**
     * Cleanup logic for component lifecycle.
     */
    destroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    /**
     * Abstract method for subscribing to user changes.
     */
    abstract subscribeToUserChanges(): void;

    /**
     * Update user status
     *
     * @param status
     */
    abstract updateUserStatus(status: string): void;

    /**
     * Sign out the user.
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
